import React, { useState } from 'react';
import Notification from '../components/ui/Notification';
import TemplateList from '../features/prompt-templates/components/TemplateList';
import TemplateEditor, { NewTemplateButton } from '../features/prompt-templates/components/TemplateEditor';
import { usePromptTemplateLibrary } from '../features/prompt-templates/hooks/usePromptTemplateLibrary';
import '../features/prompt-templates/styles/prompt-templates.css';

/**
 * The shared library of saved prompts.
 *
 * Everything here is the template itself. Custom reports only ever copy a
 * template's text, so a report edited afterwards never writes back to this page.
 */
export default function PromptTemplatesPage() {
  const [notif, setNotif] = useState(null);
  const library = usePromptTemplateLibrary(setNotif);

  return (
    <div className="prompt-templates-page">
      <div className="prompt-templates-content">
        <div className="prompt-templates-head">
          <div>
            <h1>Prompt templates</h1>
            <p>
              Saved prompts you can pick when running a custom report. Picking one copies its
              text into that report, so editing the report never changes the template.
            </p>
          </div>
          <NewTemplateButton onClick={library.startNew} />
        </div>

        <div className="prompt-templates-layout">
          <TemplateList library={library} />
          <TemplateEditor library={library} />
        </div>
      </div>

      {notif && (
        <Notification
          type={notif.type}
          title={notif.title}
          message={notif.message}
          onClose={() => setNotif(null)}
          duration={4000}
        />
      )}
    </div>
  );
}
